function AddClass(element, styleClass) {
    element.classList.add(styleClass);
}
function RemoveClass(element, styleClass) {
    element.classList.remove(styleClass);
}
function getShadowChildren(host, tagName, className) {
    if (host) {
        const children = Array.from(host?.shadowRoot?.children || host?.children);
        const matches = [];
        for (const child of children) {
            if (child.tagName === tagName &&
                (className ? child.classList.contains(className) : true)) {
                matches.push(child);
            }
        }
        return matches;
    }
}
/**
 * The same as classList.add but accepts array of css classes
 * @param {HTMLElement} el which will receive new css classes
 * @param {string[]} cssClasses which will be added to el
 */
function addCssClasses(el, cssClasses) {
    if (el && el.classList && cssClasses && cssClasses.length) {
        el.classList.add(...cssClasses.filter((element) => element));
    }
}

var BxfNotificationGroupTypeEnum;
(function (BxfNotificationGroupTypeEnum) {
    BxfNotificationGroupTypeEnum["WIDGET"] = "widget";
    BxfNotificationGroupTypeEnum["TOAST"] = "toast";
    BxfNotificationGroupTypeEnum["WIDGET_INLINE"] = "widget-inline";
    BxfNotificationGroupTypeEnum["WIDGET_TOAST"] = "widget-toast";
    BxfNotificationGroupTypeEnum["CUSTOM_POSITION_TOAST"] = "custom-position-toast";
})(BxfNotificationGroupTypeEnum || (BxfNotificationGroupTypeEnum = {}));

const BxfNotificationGroupConstants = {
    NOTIFICATION: 'bxf-notification',
    NOTIFICATION_GROUP: 'bxf-notification-group',
    NOTIFICATION_GROUP_CONTENT: 'bxf-notification-group__content',
    NOTIFICATION_GROUP_CONTENT_WIDGET_TOAST: 'bxf-notification-group__content--widget-toast',
    NOTIFICATION_GROUP_CONTENT_WIDGET_INLINE: 'bxf-notification-group__content--widget-inline',
    DIV: 'div',
    NOTIFICATION_STYLE: 'notification-style',
    BREAK: 'br',
    TYPE: 'type',
    IS_COMPACT: 'is-compact',
    IS_TOAST: 'is-toast',
    TOAST_TYPE: 'toast-type',
    TOAST_TIMEOUT: 'toast-timeout',
    KEEP_MOUSE_FOCUS: 'keep-mouse-focus',
    DATA_TEST_SUFFIX: 'data-test-suffix',
    TRUE: 'true',
    FLEX: 'flex',
};

var BxfNotificationBadgeTypeEnum;
(function (BxfNotificationBadgeTypeEnum) {
    BxfNotificationBadgeTypeEnum["ERROR"] = "error";
    BxfNotificationBadgeTypeEnum["WARNING"] = "warning";
    BxfNotificationBadgeTypeEnum["SUCCESS"] = "success";
    BxfNotificationBadgeTypeEnum["MESSAGE"] = "neutral";
})(BxfNotificationBadgeTypeEnum || (BxfNotificationBadgeTypeEnum = {}));

var BxfNotificationFooterTypeEnum;
(function (BxfNotificationFooterTypeEnum) {
    BxfNotificationFooterTypeEnum["BUTTON"] = "button";
    BxfNotificationFooterTypeEnum["LINK"] = "link";
})(BxfNotificationFooterTypeEnum || (BxfNotificationFooterTypeEnum = {}));

var BxfNotificationStyleEnum;
(function (BxfNotificationStyleEnum) {
    BxfNotificationStyleEnum["ERROR"] = "error";
    BxfNotificationStyleEnum["WARNING"] = "warning";
    BxfNotificationStyleEnum["SUCCESS"] = "success";
    BxfNotificationStyleEnum["MESSAGE"] = "message";
})(BxfNotificationStyleEnum || (BxfNotificationStyleEnum = {}));

var BxfNotificationToastTypeEnum;
(function (BxfNotificationToastTypeEnum) {
    BxfNotificationToastTypeEnum["TIMEOUT"] = "timeout";
    BxfNotificationToastTypeEnum["PERSISTENT"] = "persistent";
})(BxfNotificationToastTypeEnum || (BxfNotificationToastTypeEnum = {}));

class BxfNotificationConstants {
    static STRING = {
        CONTAINER_SHOW: 'bxf-notification__container--show',
        CONTAINER_HIDE: 'bxf-notification__container--hide',
        CONTAINER_COMPACT: 'bxf-notification__container--compact',
        CONTENT: 'bxf-notification__content',
        BUTTONS: 'bxf-notification__buttons',
        BADGE: 'bxf-notification__badge',
        BADGE_MESSAGE: 'bxf-notification__badge--message',
        BADGE_COMPACT: 'bxf-notification__badge--compact',
        CONTAINER_CONTENT_BUTTON: 'bxf-notification__content-button-container',
        CONTENT_WITH_BUTTON: 'bxf-notification__content-button',
        CONTENT_WITH_BUTTON_COMPACT: 'bxf-notification__content-button--compact',
        CONTAINER: 'bxf-notification__container',
        CLOSE_BUTTON: 'bxf-notification__close-button',
        CLOSE_BUTTON_LABEL: 'close',
        MESSAGE_LIST: 'bxf-notification__message-list',
        HEADER_PLURAL: 's',
        MESSAGE_HEADER: 'bxf-notification__message-header',
        MESSAGE_HEADER_COMPACT: 'bxf-notification__message-header--compact',
        MULTI_MESSAGE_CONTAINER: 'bxf-notification__multi-message-container',
        MESSAGE_BODY: 'oneds-blk-body-xs',
    };
}

export { AddClass as A, BxfNotificationGroupTypeEnum as B, RemoveClass as R, BxfNotificationGroupConstants as a, BxfNotificationBadgeTypeEnum as b, BxfNotificationFooterTypeEnum as c, BxfNotificationStyleEnum as d, BxfNotificationToastTypeEnum as e, BxfNotificationConstants as f, getShadowChildren as g, addCssClasses as h };
